import React from "react";
import PageShell from "../../components/layout/PageShell";
import { Link } from "react-router-dom";

export default function Gouvernance() {
  return (
    <PageShell
      title="Gouvernance"
      subtitle="Structure de direction et instances de l'École de la Magistrature"
    >
      {/* Introduction */}
      <section className="ema-block">
        <h2 className="ema-h3">Structure de gouvernance</h2>
        <p className="ema-paragraph">
          L'École de la Magistrature est dirigée par une structure de gouvernance qui garantit l'indépendance,
          la transparence et l'efficacité de l'institution. Cette structure comprend plusieurs organes qui
          collaborent pour assurer le bon fonctionnement de l'école.
        </p>
      </section>

      <div className="ema-divider" />

      {/* Direction générale */}
      <section className="ema-block">
        <h2 className="ema-h3">Direction générale</h2>
        <div className="ema-panel" style={{ marginTop: 14 }}>
          <h3 className="ema-h3">Directeur général</h3>
          <p className="ema-paragraph">
            Le directeur général assure la direction administrative et pédagogique de l'école. Il est responsable
            de la mise en œuvre de la stratégie de formation, de la gestion des ressources et des relations
            avec les partenaires institutionnels.
          </p>
          <div className="ema-inline-actions" style={{ marginTop: 12 }}>
            <Link className="ema-btn ema-btn-secondary" to="/gouvernance/kesner-michel-thermesi">
              Voir le profil du directeur
            </Link>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Directions */}
      <section className="ema-block">
        <h2 className="ema-h3">Directions opérationnelles</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Direction des Études</h3>
            <p className="ema-paragraph">
              Responsable de la conception et de la mise en œuvre des programmes de formation, de la coordination
              des enseignants et de l'évaluation des apprenants.
            </p>
            <div className="ema-inline-actions" style={{ marginTop: 12 }}>
              <Link className="ema-btn ema-btn-secondary" to="/gouvernance/maguy-florestal">
                Voir le profil
              </Link>
            </div>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Direction Administrative</h3>
            <p className="ema-paragraph">
              Gère les ressources humaines, financières et matérielles de l'école. Assure le bon fonctionnement
              des services administratifs et logistiques.
            </p>
            <div className="ema-inline-actions" style={{ marginTop: 12 }}>
              <Link className="ema-btn ema-btn-secondary" to="/gouvernance/jeanne-beanne-casty">
                Voir le profil
              </Link>
            </div>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Direction des Partenariats</h3>
            <p className="ema-paragraph">
              Développe et maintient les relations avec les institutions nationales et internationales, les
              partenaires académiques et les bailleurs de fonds.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Direction de la Communication</h3>
            <p className="ema-paragraph">
              Assure la communication interne et externe, gère les relations publiques et coordonne les
              événements institutionnels.
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Instances consultatives */}
      <section className="ema-block">
        <h2 className="ema-h3">Instances consultatives</h2>
        <div className="ema-grid-2" style={{ marginTop: 14 }}>
          <div className="ema-panel">
            <h3 className="ema-h3">Conseil d'Administration</h3>
            <p className="ema-paragraph">
              Organe de décision stratégique qui définit les orientations générales de l'école, approuve le
              budget et supervise la gestion administrative et financière.
            </p>
          </div>
          <div className="ema-panel">
            <h3 className="ema-h3">Conseil Pédagogique</h3>
            <p className="ema-paragraph">
              Instance consultative qui donne son avis sur les programmes de formation, les méthodes
              pédagogiques et l'évaluation des apprenants.
            </p>
          </div>
        </div>
      </section>

      <div className="ema-divider" />

      {/* Principes */}
      <section className="ema-block">
        <h2 className="ema-h3">Principes de gouvernance</h2>
        <div className="ema-grid-3" style={{ marginTop: 14 }}>
          <div className="ema-card ema-card-highlight">
            <h3 className="ema-h3">Transparence</h3>
            <p className="ema-paragraph">
              Communication claire et ouverte sur les décisions et activités de l'institution.
            </p>
          </div>
          <div className="ema-card ema-card-highlight">
            <h3 className="ema-h3">Responsabilité</h3>
            <p className="ema-paragraph">
              Engagement à rendre compte des actions et résultats aux parties prenantes.
            </p>
          </div>
          <div className="ema-card ema-card-highlight">
            <h3 className="ema-h3">Équité</h3>
            <p className="ema-paragraph">
              Traitement juste et équilibré de tous les membres de la communauté éducative.
            </p>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
